import { render, staticRenderFns } from "./CadastroFluxo.vue?vue&type=template&id=ba54d53a&scoped=true&"
import script from "./CadastroFluxo.vue?vue&type=script&lang=js&"
export * from "./CadastroFluxo.vue?vue&type=script&lang=js&"
import style0 from "./CadastroFluxo.vue?vue&type=style&index=0&id=ba54d53a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba54d53a",
  null
  
)

export default component.exports